// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"sS-z","inlineTitle":"tS-z","sponsoredAdsWrapper":"uS-z","marketplaceRecosWrapper":"vS-z"};